module.exports = __webpack_public_path__ + "img/up-right-from-square.bd6645e8.svg";